module.exports = __webpack_public_path__ + "assets/glyphicons-halflings-regular-f4769f.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/glyphicons-halflings-regular.eot
 ** module id = 510
 ** module chunks = 2
 **/